var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDevicesIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.591,
    height: 30.591,
    viewBox: "0 0 30.591 30.591",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "router_black_24dp",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M0,0H30.591V30.591H0Z",
    transform: "translate(0 0)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M24.924,6.7l1.02-1.02a8.925,8.925,0,0,0-12.746,0l1.02,1.02A7.971,7.971,0,0,1,19.57,4.53,7.971,7.971,0,0,1,24.924,6.7Zm-1.147,1.02a5.85,5.85,0,0,0-8.413,0l1.02,1.02a4.621,4.621,0,0,1,6.373,0Zm-.382,8.03H20.845v-5.1H18.3v5.1H5.549A2.557,2.557,0,0,0,3,18.3v5.1a2.557,2.557,0,0,0,2.549,2.549H23.394a2.557,2.557,0,0,0,2.549-2.549V18.3A2.557,2.557,0,0,0,23.394,15.746ZM9.373,22.12H6.824V19.57H9.373Zm4.461,0H11.285V19.57h2.549Zm4.461,0H15.746V19.57H18.3Z",
    transform: "translate(0.824 0.824)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevicesIcon);
export default __webpack_public_path__ + "static/media/DevicesIcon.b48af90952d0005f1dfa5905dbc0ab19.svg";
export { ForwardRef as ReactComponent };